import React, { useState, useMemo } from "react";
import "../index.less";
import {
  Tabs,
  Empty,
  Input,
  Typography,
  Row,
  Col,
  Button,
  Pagination,
  Select,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { isMobile } from "@/utils/public";
import useBaseRequest from "@/hooks/useBaseRequest";
import { getModelType, getModelList } from "@/api/index";
import Detail from "../detial";

function Home(props) {
  const { changTab } = props;
  const [activeKey, setActiveKey] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [inputCache, setInputCache] = useState("");
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const [deploymentType, setDeploymentType] = useState(undefined);
  const isMob = isMobile();
  const { data: initCate, loading: loading2 } = useBaseRequest(getModelType, {
    // manual: true,
  });

  const {
    data: initCateList,
    loading,
    runAsync: runSearch,
  } = useBaseRequest(
    () =>
      getModelList({
        category: activeKey === "0" ? "" : activeKey,
        page: current,
        size,
        search: inputValue,
        deployment_type: deploymentType ? deploymentType : "",
      }),
    {
      // manual: true,
      refreshDeps: [activeKey, current, inputValue, deploymentType],
      onSuccess(res) {
        setTotal(res?.total);
      },
    }
  );

  const tabData = [
    {
      name: "通用对话",
      id: "llm",
    },
    {
      name: "文本嵌入",
      id: "embedding",
    },
    {
      name: "重排序",
      id: "rerank",
    },
  ];

  const tablist = [
    {
      category: "llm",
      category_name: "通用对话",
      context: "32k",
      deployment_type: "local",
      deployment_type_label: "本地",
      description:
        "Qwen3 是 Qwen 系列中的最新一代大型语言模型，提供了一整套密集型和专家混合（MoE）模型。基于广泛的训练，Qwen3 在推理、指令遵循、代理能力和多语言支持方面取得了突破性进展，具有以下关键特性：\n在单个模型中无缝切换思考模式（用于复杂逻辑推理、数学和编码）和非思考模式（用于高效、通用对话），确保在各种场景下的最佳性能。\n显著增强了其推理能力，在数学、代码生成和常识逻辑推理方面超过了之前的 QwQ（在思考模式下）和 Qwen2.5 指令模型（在非思考模式下）。\n卓越的人类偏好对齐，在创意写作、角色扮演、多轮对话和指令遵循方面表现出色，提供更自然、引人入胜和沉浸式的对话体验。\n擅长代理能力，能够在思考和非思考模式下与外部工具精确集成，并在复杂的基于代理的任务中达到开源模型的领先性能。\n支持 100 多种语言和方言，具有强大的多语言指令遵循和翻译能力。\n",
      icon_url: "https://assets.watone.cn/model_image/2.jpeg",
      id: 1,
      is_general: true,
      model_id: "qwen3-32b-32k-local",
      name: "qwen3",
      param_size: "32b",
      release_date: "",
    },
    {
      category: "llm",
      category_name: "通用对话",
      context: "32k",
      deployment_type: "local",
      deployment_type_label: "本地",
      description:
        "Qwen2.5系列14B模型，相较于 Qwen2，Qwen2.5 获得了显著更多的知识，并在编程能力和数学能力方面有了大幅提升。此外，新模型在指令执行、生成长文本、理解结构化数据（例如表格）以及生成结构化输出特别是 JSON 方面取得了显著改进",
      icon_url: "",
      id: 2,
      is_general: true,
      model_id: "qwen2.5-instruct-14b-32k-local",
      name: "qwen2.5-instruct",
      param_size: "14b",
      release_date: "",
    },
    {
      category: "embedding",
      category_name: "文本嵌入",
      context: "8k",
      deployment_type: "local",
      deployment_type_label: "本地",
      description:
        "新一代多语言嵌入模型（Embedding），支持多语言文本向量化，优化检索与语义匹配任务，适配长短文本混合场景。",
      icon_url: "",
      id: 3,
      is_general: false,
      model_id: "bge-m3-0.5b-8k-local",
      name: "bge-m3",
      param_size: "0.5b",
      release_date: "",
    },
  ];

  const Items = useMemo(() => {
    const cateList = [{ name: "全部", code: "0" }, ...(initCate?.data ?? [])];
    // console.log(cateList)
    const cate = cateList?.map((item, index) => {
      return {
        title: item.name,
        key: item.code,
        children:
          activeKey === "0" || activeKey === item.code
            ? initCateList?.data.map((jtem) => {
                // console.log(jtem, "多智能体搜索当中的")
                return {
                  label: jtem.name,
                  icon: jtem?.icon_url,
                  key: jtem.id + "",
                  sj: jtem.release_date,
                  tag: jtem.deployment_type_label,
                  des: jtem.description,
                };
              })
            : [],
      };
    });
    // console.log(cate);
    return cate;
  }, [initCateList, initCate, activeKey]);
  return (
    <>
      <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
        <div className="content">
          {isMob ? (
            <>
              <div className="m-search">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Input
                      value={inputValue}
                      onChange={(e) => {
                        // setInputValue(e.target.value)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          // runSearch(inputValue)
                        }
                      }}
                      suffix={
                        <SearchOutlined
                          style={{ fontSize: 16, color: "#1677ff" }}
                        />
                      }
                      placeholder="搜索模型"
                    />
                  </Col>
                  <Col span={24}>
                    <Button type="primary">搜索</Button>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div className="pcSearch">
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Select
                    style={{
                      width: "150px",
                    }}
                    options={[
                      {
                        label: "云端",
                        value: "cloud",
                      },
                      {
                        label: "本地",
                        value: "local",
                      },
                    ]}
                    allowClear
                    value={deploymentType}
                    onChange={(val) => {
                      setDeploymentType(val);
                    }}
                    placeholder="部署类型"
                  />
                </Col>
                <Col span={12}>
                  <Input
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                    }}
                    // onKeyDown={(e) => {
                    //     if (e.key === "Enter") {
                    //         setInputValue(e.target.value)
                    //     }
                    // }}
                    suffix={
                      <SearchOutlined
                        style={{ fontSize: 16, color: "#1677ff" }}
                      />
                    }
                    placeholder="搜索模型"
                  />
                </Col>
              </Row>
            </div>
          )}

          <Tabs
            style={{
              height: "100%",
            }}
            type="card"
            key={"mxgc"}
            items={Items?.map((item, index) => {
              // console.log(item, "tabs的值")
              return {
                label: item?.title,
                key: item.key,
                children: (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "calc(100% - 50px)",
                        overflowY: "auto",
                      }}
                    >
                      <Detail
                        changTab={changTab}
                        style={{
                          width: "100%",
                        }}
                        data={item.children}
                      />
                    </div>
                    <div
                      className="fy"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        height: "50px",
                      }}
                    >
                      <Pagination
                        total={total}
                        pageSize={size}
                        current={current}
                        onChange={(cur, pageSize) => {
                          setCurrent(cur);
                          setSize(pageSize);
                        }}
                      />
                    </div>
                  </div>
                ),
              };
            })}
            tabBarGutter={15}
            activeKey={activeKey}
            onChange={(activeKey) => {
              setActiveKey(activeKey);
            }}
            tabBarExtraContent={{
              right: isMob ? undefined : (
                <div
                  style={{
                    width: "300px",
                  }}
                ></div>
              ),
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Home;
